/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiSettings = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 22H7v-2H2v-2h5v-2h2zm13-2H11v-2h11zm-8-5h-2v-2H2v-2h10V9h2zm8-2h-6v-2h6zm-1.442-8.61L23 6l-2.442 1.61L19 10l-1.559-2.39L15 6l2.441-1.61L19 2zm-2.01 1.2-.137.09-.485.32.485.32.138.09.451.692.451-.692.622-.41-.622-.41L19 4.897zM9 8H7V6H2V4h5V2h2zm4.836-4.548.084.128.128.084 1.276.836-1.276.836-.128.084-.084.128L13 6.824l-.836-1.276-.084-.128-.128-.084-1.276-.836 1.276-.836.128-.084.084-.128L13 2.176z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAiSettings as AiSettings };
